export default "__VITE_ASSET__BWBfITCs__"